import React, { FC, useContext, useState } from 'react'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import AuthenticationContext from '../Authentication/AppContext'
import AuthService from '../Authentication/AuthService'
import ProtectedButton from './ProtectedButton'

export const FlipCardContainer: FC<{}> = ({ children }) => (
  <Container fluid>
    <Row>{children}</Row>
  </Container>
)

interface FlipCardProps {
  permissions?: string[]
  headerText: String
  headerLink?: String
  flipFrontContent: JSX.Element
  customFooter?: JSX.Element
  flipBackContent?: JSX.Element
  size?: 'md' | 'lg' | 'xl'
}

export const FlipCard: FC<FlipCardProps> = ({ permissions = ['*'], headerText, headerLink, flipFrontContent, customFooter, flipBackContent, size }) => {
  const { userPermissions } = useContext(AuthenticationContext)
  const [flipped, setFlipped] = useState(false)
  const { t } = useTranslation()

  if (!AuthService.hasPermission(userPermissions, permissions)) return <></>

  const md = size === 'xl' || size === 'lg' ? 12 : 6
  const lg = size === 'xl' ? 12 : size === 'lg' ? 6 : 3

  return (
    <Col xs={12} md={md} lg={lg} className={flipped ? 'p-3 flip-card flipped' : 'p-3 flip-card'}>
      <div className='flip-card-inner'>
        <Card bg='dark' className='text-center flip-card-front'>
          {headerText !== undefined && (
            <Card.Header as='h3' className='text-white border-bottom-primary p-1'>
              {headerLink !== undefined && (
                <ProtectedButton permissions={permissions} variant='link' href={headerLink} className='m-1 text-decoration-none text-link text-white'>
                  <h3>{headerText}</h3>
                </ProtectedButton>
              )}
              {headerLink === undefined && headerText}
            </Card.Header>
          )}
          <Card.Body className='d-flex justify-content-center align-items-center text-white'>
            <h5 className='w-100'>{flipFrontContent}</h5>
          </Card.Body>
          {customFooter === undefined && flipBackContent && (
            <Card.Footer className='border-top-primary'>
              <Button onClick={() => setFlipped(true)} variant='link'>
                {t('quickLinks')} &gt;
              </Button>
            </Card.Footer>
          )}
          {customFooter !== undefined && <Card.Footer className='border-top-primary'>{customFooter}</Card.Footer>}
        </Card>
        {flipBackContent && (
          <Card bg='dark' className='text-center flip-card-back'>
            {headerText !== undefined && (
              <Card.Header as='h3' className='text-white border-bottom-primary p-1'>
                {headerLink !== undefined && (
                  <ProtectedButton permissions={permissions} variant='link' href={headerLink} className='m-1 text-decoration-none text-link text-white'>
                    <h3>{headerText}</h3>
                  </ProtectedButton>
                )}
                {headerLink === undefined && headerText}
              </Card.Header>
            )}
            <Card.Body className='text-white'>{flipBackContent}</Card.Body>
            <Card.Footer className='border-top-primary'>
              <Button onClick={() => setFlipped(false)} variant='link'>
                &lt; {t('goBack')}
              </Button>
            </Card.Footer>
          </Card>
        )}
      </div>
    </Col>
  )
}
